



























import { Component, Vue, Prop } from 'vue-property-decorator';

import { User } from '@/models/User';

import UserCard from '@/components/user/UserCard.vue';
import UserCardLoading from '@/components/user/UserCardLoading.vue';

@Component({
    name: 'UserCards',
    components: {
        UserCard,
        UserCardLoading,
    },
})
export default class UserCards extends Vue {
    @Prop(Array) private users: User[];
    @Prop(Boolean) private isLoading: boolean;
}
